if (typeof DownloadButton !== 'function') {
	class DownloadButton extends HTMLElement {
		constructor() {
			super();

			this.button = this.querySelector('button');
			this.button.addEventListener('click', () => this.handleClick());
		}

		// Event handler for button click
		handleClick() {
			const urls = this.getAttribute('data-urls');

			if (!urls) {
				console.log('No URLs provided in the data-urls attribute.');
				return;
			}

			const urlArray = urls.split(',').map((url) => url.trim());
			urlArray.forEach((url) => {
				const anchor = document.createElement('a');
				anchor.href = url.startsWith('//') ? 'https:' + url : url;
				anchor.download = url.split('/').pop().split('?')[0];
				document.body.appendChild(anchor);
				anchor.click();
				document.body.removeChild(anchor);
			}); 
		}
	}

	if (!customElements.get('download-button')) {
		customElements.define('download-button', DownloadButton);
	}
}
